module.exports = __webpack_public_path__ + "static/media/Home.d66347a0.png";